import React from 'react';

const LocationMap = ({ location }) => {
  if (!location) return null;

  return (
    <div className="w-full h-full rounded-xl overflow-hidden border border-[var(--color-border)]">
      <iframe
        width="100%"
        height="100%"
        loading="lazy"
        title={location?.name}
        referrerPolicy="no-referrer-when-downgrade"
        src={`https://www.google.com/maps?q=${location?.lat},${location?.lng}&z=14&output=embed`}
        className="w-full h-full"
      />
    </div>
  );
};

export default LocationMap;